module.exports = __webpack_public_path__ + "static/Workware-35f4afbaf649cc9ace1fcd48db3259c7.jpg";